import { defineMessages } from 'react-intl';

export default defineMessages({
    insuranceIDCard: {
        id: 'portal.views.android-steps-modal.Insurance ID Card',
        defaultMessage: 'Insurance ID Card'
    },
    followTheseSteps: {
        id: 'portal.views.android-steps-modal.Follow these steps to download the ID card to Google Wallet.',
        defaultMessage: 'Follow these steps to download the ID card to Google Wallet.'
    },
    usingYourAndroidDevice: {
        id: 'portal.views.android-steps-modal.Using your Android device Download Google Wallet for Android.',
        defaultMessage: 'Using your Android device Download Google Wallet for Android.'
    },
    onceGoogleWalletInstalled: {
        id: 'portal.views.android-steps-modal.Once Google Wallet is installed on your Android device',
        defaultMessage: 'Once Google Wallet is installed on your Android device select your vehicle from the list below and use the button beneath the title to download your digital ID Card.'
    },
    theCardIsNowAdded: {
        id: 'portal.views.android-steps-modal.The card is now added to Google Wallet',
        defaultMessage: 'The card is now added to Google Wallet. It will be available in the Google Wallet app with or without internet access. If you make changes to your policy or your policy renews you will need to re-download the ID Card.'
    },
    selectTheVehicle: {
        id: 'portal.views.android-steps-modal.Select the vehicle you want an ID card for.',
        defaultMessage: 'Select the vehicle you want an ID card for.'
    },
    download: {
        id: 'portal.views.android-steps-modal.Download',
        defaultMessage: 'Download {year} {make} {model} ({vehicleNumber})'
    },
    downloadAndroidIdCardTrackButtonIdentifier: {
        id: 'portal.views.android-steps-modal.tracking.Download',
        defaultMessage: 'Download Android ID Card'
    },
    downloadGoogleWalletTrackButtonIdentifier: {
        id: 'portal.views.android-steps-modal.tracking.Download Google Wallet',
        defaultMessage: 'Download Google Wallet'
    },
    close: {
        id: 'portal.views.android-steps-modal.Close',
        defaultMessage: 'Close'
    }
});
